<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
        <div class="d-inline-block">
          <div class="form-group d-flex align-items-center">
            <label class="mb-0 mr-2">slug:</label>
            <input v-model="item['slug']" type="text" class="form-control">
          </div>
        </div>
      </div>

    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">
      <input type="text" placeholder="زیر دسته" class="mb-2 form-control" v-model="item['sub_category']">
    </div>
    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "CategoryInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>

</style>